export function shareButton(element: Element): void {
    const shareButton = element.querySelector(".js-share-button");
    const popup = element.querySelector(".socialShare__popup");
    let isPopupOpen = false;

    // Function to open the popup
    function togglePopup() {
      if(popup.classList.contains('active')) {
        popup.classList.remove('active');
      } else {
        popup.classList.add('active');
      }
      isPopupOpen = true;
    }

    // Open the popup when the share button is clicked
    shareButton.addEventListener("click", togglePopup);

    // Close the popup when clicking outside of it
    // document.addEventListener("click", function (event) {
    //   console.log(isPopupOpen)
    //   if (event.target !== shareButton && event.target !== popup && event.target !== element) {
    //     closePopup();
    //   }
    // });

    // Prevent clicks inside the popup from closing it
    popup.addEventListener("click", function (event) {
      event.stopPropagation();
    });
}